import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  productsPageView: 'grid' | 'table';
  productsPageFilter: 'ALL' | 'MINE';
}

interface UIActions {
  setProductsPageView: (view: 'grid' | 'table') => void;
  setProductsPageFilter: (filter: 'ALL' | 'MINE') => void;
}

const initialState: UIState = {
  productsPageView: 'grid',
  productsPageFilter: 'ALL',
};

export const useUiStore = create<UIState & UIActions>()(
  persist(
    (set) => ({
      ...initialState,
      setProductsPageView: (view) => set((state) => ({ ...state, productsPageView: view })),
      setProductsPageFilter: (filter) => set((state) => ({ ...state, productsPageFilter: filter })),
    }),

    {
      name: 'process-manager-ui',
    },
  ),
);
